import { PaymentProvider } from './types';
import { OnlineMethodsByProvider } from './constants';
import { getPaymentProviders } from './providers';
import { PaymentMethod, Commission, CurrencyObject } from 'common/types/common';
import { getPricingString, notNull } from 'common/utils/common';
import {
	getCurrencyObjectFromCurrencyCode,
	getDefaultCurrencyObject,
} from 'common/utils/currencyUtils';

export const getPaymentMethodProvider = (method: PaymentMethod): PaymentProvider => {
	const providers = getPaymentProviders();
	for (const provider of providers) {
		const paymentMethods = Object.values(OnlineMethodsByProvider[provider]);
		if ((paymentMethods as string[]).includes(method)) {
			return provider;
		}
	}
	return 'MANUAL';
};

export const getPaymentCommissionString = (
	commission: Commission,
	shopCurrency?: CurrencyObject,
) => {
	const hasFixedPrice = commission.fixedInCents !== 0;
	const hasPercentage = commission.percentageInDecimals !== 0;
	const fixedString = getPricingString(
		commission.fixedInCents,
		getCurrencyObjectFromCurrencyCode(
			commission.currency ?? getDefaultCurrencyObject().code,
			shopCurrency,
		),
	);
	const percentageString = `${(commission.percentageInDecimals * 100).toFixed(2)} %`;
	const priceArray = [
		hasFixedPrice ? fixedString : null,
		hasPercentage ? percentageString : null,
	].filter(notNull);
	if (!!priceArray.length) {
		return priceArray.join(' + ');
	}
	return '-';
};

export const mapPaymentTerritoryToCountry = (countryCode: string) => {
	switch (countryCode) {
		case 'PR':
			return 'US'; // Note, only Puerto Rico supported at the moment for US payments. Axel Cedercreutz (16.8.2022)
		case 'JE':
		case 'IM':
			return 'GB';
		default:
			return countryCode;
	}
};
